// extracted by mini-css-extract-plugin
export default {"nav":"authMenu_nav__zd4W-","headerMenu":"authMenu_headerMenu__WZLwT","link":"authMenu_link__Yccx+","active":"authMenu_active__C9o43 authMenu_link__Yccx+"};